import { CreateExitMobileIcon } from '@/icons'
import { Modal } from 'antd'
import React, { CSSProperties, ReactNode, memo } from 'react'
import '../../app/globals.css'
import LoadingImg from '@/icons/LoadingImg'
import { twMerge } from 'tailwind-merge'

interface Props {
  children?: ReactNode
  title?: ReactNode
  footer?: ReactNode
  width?: number | string
  open?: boolean
  centered?: boolean
  footerClassName?: string
  headerClassName?: string
  maskClosable?: boolean
  onCancel?: () => void
  destroyOnClose?: boolean
  isLoading: boolean
  hideCloseIcon?: boolean
  customStyles?: Record<string, CSSProperties>
  bodyStyle?: CSSProperties
  bodyContentClassName?: string
  childrenWrapperClassName?: string
  modalStyle?: CSSProperties
  mask?: boolean
  zIndex?: number
}

const commonStyles: Record<string, CSSProperties> = {
  content: {
    background:
      'linear-gradient(180deg, rgba(24, 14, 31, 1) 0%, rgba(65, 35, 77, 1) 50%, rgba(29, 21, 21, 1) 100%)',
    borderRadius: '10px',
    border: '1px solid rgba(255,255,255,0.6)',
    color: 'var(--primary-text-color)',
    padding: 0,
  },
}

const CommonModal = ({
  children,
  footer,
  title,
  footerClassName,
  headerClassName,
  centered = true,
  maskClosable = true,
  onCancel,
  open,
  width = 368,
  destroyOnClose = false,
  isLoading = false,
  hideCloseIcon = false,
  customStyles,
  bodyStyle,
  bodyContentClassName,
  childrenWrapperClassName,
  modalStyle,
  mask = true,
  zIndex,
}: Props) => {
  return (
    <Modal
      closeIcon={hideCloseIcon ? null : <CreateExitMobileIcon />}
      footer={null}
      styles={{ ...commonStyles, ...customStyles }}
      style={modalStyle}
      centered={centered}
      width={width}
      maskClosable={maskClosable}
      destroyOnClose={destroyOnClose}
      open={open}
      onCancel={onCancel}
      mask={mask}
      zIndex={zIndex}
    >
      <div
        className="flex w-full flex-col items-center py-5 pl-5 pr-3"
        style={{ maxHeight: 'calc(100vh - 100px)', ...bodyStyle }}
      >
        {isLoading && (
          <div className="absolute inset-0 flex items-center justify-center bg-white/10">
            <LoadingImg className="scale-[.8]" />
          </div>
        )}
        {title && (
          <header
            className={twMerge(
              'mb-4 w-full max-w-[calc(100%-60px)] break-words px-3 text-center',
              headerClassName
            )}
          >
            {title}
          </header>
        )}
        <div
          className={twMerge(
            'transition-scrollbar-slim w-full flex-1 overflow-y-auto [scrollbar-gutter:stable]',
            bodyContentClassName
          )}
        >
          <div className={twMerge('relative', childrenWrapperClassName)}>
            {children}
          </div>
        </div>
        {footer && (
          <footer className={twMerge('w-full pr-2', footerClassName)}>
            {footer}
          </footer>
        )}
      </div>
    </Modal>
  )
}

export type { Props as CommonModalProps }
export default memo(CommonModal)
